var _path, _rect, _path2, _path3, _g, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _g10, _path20, _g11, _path21, _g12, _path22, _g13, _path23, _g14, _path24, _g15, _path25, _g16, _path26, _g17, _path27, _g18, _path28, _g19, _path29, _g20, _path30, _g21, _path31, _g22, _path32, _g23, _path33, _g24, _path34, _g25, _path35, _g26, _path36, _path37, _g27, _path38, _g28, _path39, _g29, _path40, _g30, _path41, _g31, _path42, _g32, _path43, _g33, _path44, _g34, _path45, _g35, _path46, _g36, _path47, _g37, _path48, _g38, _path49, _g39, _path50, _g40, _path51, _g41, _path52, _g42, _path53, _g43, _path54, _g44, _path55, _g45, _path56, _g46, _path57, _g47, _path58, _g48, _path59, _g49, _path60, _g50, _path61, _g51, _path62, _g52, _path63, _g53, _path64, _g54, _path65, _g55, _path66, _g56, _path67, _g57, _path68, _g58, _path69, _g59, _path70, _g60, _path71, _g61, _path72, _g62, _path73, _g63, _path74, _g64, _path75, _g65, _path76, _g66, _path77, _g67, _path78, _g68, _path79, _g69, _path80, _g70, _path81, _g71, _path82, _g72, _path83, _g73, _path84, _g74, _path85, _g75, _path86, _g76, _path87, _g77, _path88, _g78, _path89, _g79, _path90, _g80, _path91, _g81, _path92, _g82, _path93, _g83, _path94, _g84, _path95, _g85, _path96, _g86, _path97, _g87, _path98, _g88, _path99, _g89, _path100, _g90, _path101, _g91, _path102, _g92, _path103, _g93, _path104, _g94, _path105, _g95, _path106, _g96, _path107, _g97, _path108, _g98, _path109, _g99, _path110, _g100, _path111, _g101, _path112, _g102, _path113, _g103, _path114, _g104, _path115, _g105, _path116, _g106, _path117, _g107, _path118, _g108, _path119, _g109, _path120, _g110, _path121, _g111, _path122, _g112, _path123, _g113, _path124, _g114, _path125, _g115, _path126, _g116, _path127, _g117, _path128, _g118, _path129, _g119, _path130, _g120, _path131, _g121, _path132, _g122, _path133, _g123, _path134, _g124, _path135, _g125, _path136, _g126, _path137, _g127, _path138, _g128, _path139, _g129, _path140, _g130, _path141, _g131, _path142, _g132, _path143, _g133, _path144, _g134, _path145, _g135, _path146, _g136, _path147, _g137, _path148, _g138, _path149, _g139, _path150, _g140, _path151, _g141, _path152, _g142, _path153, _g143, _path154, _g144, _path155, _g145, _path156, _g146, _path157, _g147, _path158, _g148, _path159, _g149, _path160, _g150, _path161, _g151, _path162, _g152, _path163, _g153, _path164, _g154, _path165, _g155, _path166, _g156, _path167, _g157, _path168, _g158, _path169, _g159, _path170, _g160, _path171, _g161, _path172, _g162, _path173, _g163, _path174, _g164, _path175, _g165, _path176, _g166, _path177, _g167, _path178, _g168, _path179, _g169, _path180, _g170, _path181, _g171, _path182, _g172, _path183, _g173, _path184, _g174, _path185, _g175, _path186, _g176, _path187, _g177, _path188, _g178, _path189, _g179, _path190, _g180, _path191, _g181, _path192, _g182, _path193, _g183, _path194, _g184, _path195, _g185, _path196, _g186, _path197, _g187, _path198, _g188, _path199, _g189, _path200, _g190, _path201, _g191, _path202, _g192, _path203, _g193, _path204, _g194, _path205, _g195, _path206, _g196, _path207, _g197, _path208, _g198, _path209, _g199, _path210, _g200, _path211, _g201, _path212, _g202, _path213, _g203, _path214, _g204, _path215, _g205, _path216, _g206, _path217, _g207, _path218, _g208, _path219, _g209, _path220, _g210, _path221, _g211, _path222, _g212, _path223, _g213, _path224, _g214, _path225, _g215, _path226, _g216, _path227, _g217, _path228, _g218, _path229, _g219, _path230, _g220, _path231, _g221, _path232, _g222, _path233, _g223, _path234, _g224, _path235, _g225, _path236, _g226, _path237, _g227, _path238, _g228, _path239, _g229, _path240, _g230, _path241, _g231, _path242, _g232, _path243, _g233, _path244, _g234, _path245, _g235, _path246, _g236, _path247, _g237, _path248, _g238, _path249, _g239, _path250, _g240, _path251, _g241, _path252, _g242, _path253, _g243, _path254, _g244, _path255, _g245, _path256, _g246, _path257, _g247, _path258, _g248, _path259, _g249, _path260, _g250, _path261, _g251, _path262, _g252, _path263, _g253, _path264, _g254, _path265, _g255, _path266, _g256, _path267, _g257, _path268, _g258, _path269, _g259, _path270, _g260, _path271, _g261, _path272, _g262, _path273, _g263, _path274, _g264, _path275, _g265, _path276, _g266, _path277, _g267, _path278, _g268, _path279, _g269, _path280, _g270, _path281, _g271, _path282, _g272, _path283, _g273, _path284, _g274, _path285, _g275, _path286, _g276, _path287, _g277, _path288, _g278, _path289, _g279, _path290, _g280, _path291, _g281, _path292, _g282, _path293, _g283, _path294, _g284, _path295, _g285, _path296, _g286, _path297, _g287, _path298, _g288, _path299, _g289, _path300, _g290, _path301, _g291, _path302, _g292, _path303, _g293, _path304, _g294, _path305, _g295, _path306, _g296, _path307, _g297, _path308, _g298, _path309, _g299, _path310, _g300, _path311, _g301, _path312, _g302, _path313, _g303, _path314, _g304, _path315, _g305, _path316, _g306, _path317, _g307, _path318, _g308, _path319, _g309, _path320, _g310, _path321, _g311, _path322, _g312, _path323, _g313, _path324, _g314, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 133,
    viewBox: "0 0 163 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163,
    height: 133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H81.5H163V133H81.5H0V0Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1118)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 164,
    height: 135
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 164,
    height: 134.848,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1118)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 -0.558716H-2.06888V133.774H168.002V-0.558716Z",
    fill: "url(#paint0_linear_0_1118)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -1,
    width: 122,
    height: 111
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96798 -1C1.16815 0.997421 -0.524241 3.11158 -2.06888 5.31652V81.0499C9.92556 98.1058 29.8044 109.26 52.3023 109.26C88.9304 109.26 118.628 79.6751 118.628 43.1767C118.628 26.1987 112.194 10.6992 101.623 -1H2.96798Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.628 -1H-2.06888V109.26H118.628V-1Z",
    fill: "url(#paint1_radial_0_1118)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9447 41.0498C79.9447 61.7892 62.5374 78.5987 41.0602 78.5987C19.583 78.5987 2.17563 61.7892 2.17563 41.0498C2.17563 20.3103 19.583 3.50085 41.0602 3.50085C62.5374 3.50085 79.9447 20.3103 79.9447 41.0498Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 13,
    width: 18,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4263 13.6318H19.2473V35.7072H36.4263V13.6318Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7751 15.8232L22.4574 19.7013L19.2473 27.8467L20.5502 34.9284L27.0779 35.7067C27.0779 35.7067 32.0073 30.0776 32.5983 29.014C33.2027 27.9504 36.2114 22.7105 36.2114 21.3486C36.2114 19.9867 36.4129 13.6831 36.4129 13.6831C36.4129 13.6831 27.2928 13.0995 25.7751 15.8232Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 45,
    width: 34,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9983 45.7061H15.6744V72.1006H48.9983V45.7061Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7277 51.9188C15.7277 51.9188 16.8291 59.4935 17.4335 60.3625C18.0379 61.2315 23.7598 67.4442 23.7598 67.4442L37.1243 71.6207L48.9844 72.1006V64.7205L32.3561 63.8515L22.3629 53.2807L21.3556 45.7061C21.3556 45.7061 15.0024 47.4311 15.7277 51.9188Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 35,
    width: 14,
    height: 25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1845 35.7188H54.8006V59.3895H67.1845V35.7188Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3243 59.3895L62.4565 51.7241L67.1845 44.2532L66.889 35.7188C66.889 35.7188 57.742 39.7006 57.648 39.986C57.554 40.2713 56.0362 45.7059 56.0362 45.7059C56.0362 45.7059 53.82 53.3713 55.3243 59.3895Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 28,
    width: 18,
    height: 27
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8614 28.2354H27.8301V54.7206H44.8614V28.2354Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6509 37.0681L43.1552 48.6116L44.3641 54.7206L36.426 54.6298L30.9996 49.0007C30.9996 49.0007 27.682 41.8152 27.8297 41.4261C27.9775 41.037 40.7375 33.6569 41.6509 32.8917C42.5508 32.1135 44.861 28.2354 44.861 28.2354L41.6509 37.0681Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 6,
    width: 25,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9759 6.7041H41.0468V28.7276H65.9759V6.7041Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1849 12.9038L50.9995 21.9311L54.8006 27.8455L64.4714 28.7146H65.9758L62.9671 15.42L51.8188 6.69104C51.8188 6.69104 40.7646 7.08015 41.0735 7.56005C41.3825 8.03995 42.457 8.63658 47.1849 12.9038Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 23,
    width: 10,
    height: 27
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6744 23.6837H6.89011V49.3H15.6744V23.6837Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8195 33.0998L8.5019 39.2088L6.89011 47.9377L8.19297 49.2996L15.6744 38.9104L15.2311 23.6833L11.8195 33.0998Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_0_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 53,
    width: 18,
    height: 14
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.711 53.67H54.8006V66.3939H71.711V53.67Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8006 66.3809C54.8006 66.3809 66.6876 63.2681 67.1846 62.9698C67.6816 62.6844 71.7111 53.6571 71.7111 53.6571C71.7111 53.6571 62.6716 54.9152 61.5567 56.3679C60.4553 57.8206 54.8006 65.9789 54.8006 65.9789V66.3809Z",
    fill: "#C1C4B3"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.256 6.95091C124.591 6.95091 124.591 6.44507 124.256 6.44507C123.92 6.44507 123.92 6.95091 124.256 6.95091Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.829 9.9597C139.165 9.9597 139.165 9.45386 138.829 9.45386C138.493 9.45386 138.493 9.9597 138.829 9.9597Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.379 20.0506C128.715 20.0506 128.715 19.5448 128.379 19.5448C128.043 19.5448 128.043 20.0506 128.379 20.0506Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.301 8.40391C112.637 8.40391 112.637 7.89807 112.301 7.89807C111.966 7.89807 111.966 8.40391 112.301 8.40391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79004 5.69249C8.12583 5.69249 8.12583 5.18665 7.79004 5.18665C7.45425 5.18665 7.45425 5.69249 7.79004 5.69249Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.355 11.1274C81.6908 11.1274 81.6908 10.6216 81.355 10.6216C81.0192 10.6216 81.0058 11.1274 81.355 11.1274Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.256 4.52562C104.592 4.52562 104.592 4.01978 104.256 4.01978C103.92 4.01978 103.92 4.52562 104.256 4.52562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.062 23.54C105.398 23.54 105.398 23.0342 105.062 23.0342C104.726 23.0342 104.726 23.54 105.062 23.54Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2239 31.6985C96.5597 31.6985 96.5597 31.1926 96.2239 31.1926C95.8881 31.1926 95.8881 31.6985 96.2239 31.6985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8351 19.4156V19.0265C86.8351 18.8968 86.7143 18.7671 86.5799 18.7801C86.4322 18.7801 86.3247 18.8968 86.3247 19.0265V19.4156C86.3247 19.5453 86.4456 19.675 86.5799 19.6621C86.7143 19.6621 86.8351 19.5583 86.8351 19.4156Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5959 8.01402C90.9317 8.01402 90.9317 7.50818 90.5959 7.50818C90.2601 7.50818 90.2601 8.01402 90.5959 8.01402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4715 2.20408C64.8073 2.20408 64.8073 1.69824 64.4715 1.69824C64.1357 1.69824 64.1357 2.20408 64.4715 2.20408Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2398 3.35789C18.5756 3.35789 18.5756 2.85205 18.2398 2.85205C17.904 2.85205 17.904 3.35789 18.2398 3.35789Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.285 35.1867C108.621 35.1867 108.621 34.6809 108.285 34.6809C107.936 34.6809 107.936 35.1867 108.285 35.1867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.929 24.7068C118.265 24.7068 118.265 24.2009 117.929 24.2009C117.594 24.2009 117.594 24.7068 117.929 24.7068Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.473 31.6985C148.809 31.6985 148.809 31.1926 148.473 31.1926C148.137 31.1926 148.137 31.6985 148.473 31.6985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: -1,
    width: 210,
    height: 135
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.639 -1H-21.706V133.774H187.639V-1Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.861 6.0814C147.197 6.0814 147.197 5.57556 146.861 5.57556C146.525 5.57556 146.525 6.0814 146.861 6.0814Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 115.201H-2.06888V133.774H168.002V115.201Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.002 115.006H-2.06885V133.58H168.002V115.006Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6816 112.763L17.2055 97.1726C17.2055 97.1726 15.3922 96.3684 14.0893 97.1726C14.0893 97.1726 11.8597 97.419 11.3896 96.122C11.3896 96.122 10.3553 94.4748 9.3614 96.5241C9.3614 96.5241 8.74354 91.7251 8.21971 90.1297C8.21971 90.1297 8.78384 87.3801 9.1062 89.0273C9.1062 89.0273 9.46885 92.4255 11.7522 92.8794C11.7522 92.8794 15.7414 93.5798 17.8233 91.8288C17.8233 91.8288 18.3472 91.3749 19.1262 91.9845C19.1262 91.9845 23.0214 93.93 24.5123 92.7886C24.5123 92.7886 27.4135 91.1933 23.6258 88.9365L36.0232 69.0401C36.0232 69.0401 37.0037 67.4966 35.3516 66.4849L33.0682 65.2917L36.3187 65.8364L45.882 70.83L54.4379 75.0842C54.4379 75.0842 55.217 73.3851 54.2365 71.9843C54.2365 71.9843 53.8872 70.9856 55.0289 72.1789C55.0289 72.1789 55.7139 73.2165 56.0363 74.3838C56.0363 74.3838 56.3184 75.8884 57.46 76.511L58.6017 77.2762C58.6017 77.2762 59.0853 76.5369 58.6017 75.5123L52.6247 68.9752C52.6247 68.9752 52.1008 67.9765 53.1082 68.638C53.1082 68.638 55.7677 69.8702 58.5749 69.8702L58.8301 66.4071C58.8301 66.4071 55.1901 64.0465 54.7737 62.4382L56.0229 58.9752C56.0229 58.9752 57.5406 59.8701 58.5077 59.9479L58.5749 56.7832C58.5749 56.7832 64.9012 43.6573 64.9415 43.5146C64.9818 43.3849 64.9415 42.9439 64.9415 42.9439C64.9415 42.9439 63.9341 42.7753 64.9549 41.8804L64.8072 39.3122C64.8072 39.3122 62.873 39.5327 62.2014 38.9102C62.2014 38.9102 60.6702 37.5094 57.769 37.7558L56.399 37.5353C56.399 37.5353 55.7811 37.2111 56.9899 37.2111C56.9899 37.2111 58.9107 37.2629 59.6628 36.4847H62.7521C62.7521 36.4847 64.0281 36.381 64.2565 35.7065L64.1759 33.7869C64.1759 33.7869 64.6728 32.9568 64.7669 33.7869L65.3176 41.9322C65.3176 41.9322 66.4592 41.9582 65.6802 43.1125L65.7071 43.6573L72.0468 56.2514V59.7793L74.4376 58.5471L74.7466 64.5394C74.7466 64.5394 73.8869 66.1088 72.0871 67.4447L72.0468 69.3384C72.0468 69.3384 73.8063 71.0764 79.6894 69.8702L77.9299 71.673L76.7344 72.153L72.2214 76.4461L72.4095 79.7016L87.9901 71.5434L92.6509 69.4811C92.6509 69.4811 93.8732 69.4422 92.6509 70.0518L90.2869 71.0894C90.2869 71.0894 88.9169 71.8028 88.8363 75.0194L88.8766 90.5837C88.8766 90.5837 88.796 92.1142 90.9182 92.1142C90.9182 92.1142 90.5959 92.7368 88.8498 92.8016C88.8498 92.8016 86.5798 93.1648 86.2172 91.751C86.2172 91.751 86.056 90.4799 85.6665 91.6473C85.6665 91.6473 85.2501 92.4255 85.2501 93.943L86.1366 115.474H56.1572H16.8025L16.6816 112.763Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7016 103.684L77.0031 108.755L80.764 108.366L81.3684 103.956L77.7016 103.684Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5619 105.241L69.0784 113.062L62.8999 111.661L62.779 104.566L64.6191 103.58L69.5619 105.241Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4544 101.635V105.759H43.7062L43.3301 101.323H38.2798L38.4544 101.635Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1758 102.296H29.0926V106.589H33.1758V102.296Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3039 79.6631L33.2965 82.8149L36.7484 83.7098L37.7826 80.3116L34.3039 79.6631Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3825 80.1429V84.1118H45.6403V80.0651L41.3825 80.1429Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0186 70.467V72.3477C39.0186 72.3477 39.1529 73.4761 39.7439 72.3477C39.7439 72.3477 40.6304 71.4008 39.7439 70.467C39.7573 70.467 39.6499 69.7406 39.0186 70.467Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8372 82.8662L79.5417 86.3422H82.4967L82.7384 83.2423L79.8372 82.8662Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8912 61.2452V66.0702H62L61.812 61.2452H59.8912Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7924 59.4033L63.1819 66.6148L66.0429 66.4462L65.7608 59.4033H62.7924Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6621 60.9983L68.9979 66.6144L71.5902 65.4471L71.147 59.9736L68.6621 60.9983Z",
    fill: "#CADB2B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.875 79.6363C156.317 80.2459 149.319 80.4794 149.319 80.4794L149.467 80.1422C150.38 78.8322 155.296 76.9904 155.296 76.9904L154.383 77.0682C151.79 77.4314 146.351 79.9217 146.351 79.9217L142.912 80.0514L142.858 79.8957C145.894 79.3251 148.446 77.2498 148.446 77.2498C148.943 76.5364 151.011 76.5364 151.011 76.5364L154.222 75.6674L151.28 75.7712L150.904 75.5118L152.462 74.993C153.993 74.6039 152.637 74.4482 152.637 74.4482L151.226 74.7855L154.987 71.1668C155.605 70.2977 154.638 70.7517 154.638 70.7517C153.134 71.1927 149.789 75.0578 149.789 75.0578H149.144C147.022 74.6168 144.228 71.932 144.228 71.932L147.264 72.0358C149.265 71.8542 152.059 69.8827 152.059 69.8827C153.174 69.2472 152.005 69.1693 152.005 69.1693L147.627 70.7387L142.738 70.635L148.298 68.3781C149.185 68.5597 153.443 68.456 153.443 68.456C155.054 68.3263 153.443 67.6648 153.443 67.6648C152.328 68.1836 149.682 67.7426 149.682 67.7426L152.502 67.0033C154.356 66.264 152.502 66.1602 152.502 66.1602C150.353 66.3418 146.888 67.9112 146.888 67.9112L141.65 70.4793L137.244 71.2965L140.333 67.2627L142.711 67.1849C145.679 66.7439 148.5 65.0837 148.5 65.0837C149.964 64.2666 148.621 64.2925 148.621 64.2925L145.76 65.4469C143.906 66.2121 141.824 66.0176 141.824 66.0176L143.705 64.3963C145.975 61.7503 147.761 61.3223 147.761 61.3223C149.709 60.7516 147.761 60.4793 147.761 60.4793C145.531 60.8165 141.999 64.9929 141.999 64.9929L138.292 66.8087L133.053 70.1421L137.942 65.7063L133.94 68.2484L130.407 71.3483L126.62 75.4599L129.319 70.2199L138.708 62.4767C139.568 61.2445 138.063 61.8411 138.063 61.8411C136.828 62.8139 129.91 68.6116 129.91 68.6116L131.468 65.408C133.698 63.8126 135.055 60.5311 135.055 60.5311C135.055 58.5856 134.168 60.2977 134.168 60.2977C133.523 62.5026 131.75 63.7607 131.75 63.7607C132.167 60.4274 133.134 58.5986 133.134 58.5986C133.403 56.8087 132.274 58.391 132.274 58.391C131.28 60.0642 130.421 64.8632 130.421 64.8632L128.621 68.7932L125.357 75.408L122.912 78.6376C122.442 79.4288 122.348 78.6117 122.348 78.6117C122.348 76.2511 123.289 74.4612 123.289 74.4612L126.472 69.0007C127.587 67.7685 129.118 65.408 129.118 65.408C129.534 64.1239 128.54 65.0188 128.54 65.0188L127.56 66.6401L128.473 62.1265C128.822 60.2069 127.761 62.1784 127.761 62.1784C126.902 63.9293 125.787 68.6246 125.787 68.6246L122.254 74.6558C121.368 75.9658 121.072 80.3756 121.072 80.3756L119.165 83.709C118.493 84.9412 118.453 83.6312 118.453 83.6312L119.125 81.1409C119.595 79.4937 119.796 76.2381 119.796 76.2381L119.944 71.9839L123.06 69.0526C124.094 67.8464 124.471 65.7971 124.471 65.7971L127.264 61.5947L128.151 59.1822L123.409 63.7218L120.293 67.8982L119.38 68.1058C119.232 67.2886 118.816 67.7685 118.816 67.7685L118.722 69.2082L117.607 69.3898L119.286 66.1602L122.792 63.1122L118.964 64.3963L120.844 61.6466L125.76 55.9526L120.696 60.1291L121.462 57.107C121.462 57.107 120.374 58.417 120.28 58.417C120.186 58.417 122.872 52.5155 122.872 52.5155L116.573 61.6985L112.691 65.395C112.1 66.3418 111.402 65.3431 111.402 65.3431C110.958 64.526 109.79 63.5013 109.79 63.5013C109.441 63.1122 109.441 62.3989 109.441 62.3989C110.179 60.7776 109.615 56.3677 109.615 56.3677C107.614 54.0849 108.379 56.0304 108.379 56.0304C109.494 57.107 108.621 61.6985 108.621 61.6985C108.621 62.9047 108.03 62.4118 108.03 62.4118C106.969 61.919 105.116 60.5441 105.116 60.5441C104.202 60.155 104.847 61.2315 104.847 61.2315C105.438 61.8282 107.372 62.9825 107.372 62.9825C110.408 63.7218 110.784 66.5493 110.784 66.5493C111.496 68.2744 110.166 67.6518 110.166 67.6518C108.836 66.0046 105.465 64.3703 105.465 64.3703C103.96 63.7607 105.116 64.6297 105.116 64.6297C106.969 65.369 109.118 67.7037 109.118 67.7037C110.085 68.6116 109.561 69.753 109.561 69.753L106.432 72.6583C104.484 73.7219 103.302 75.2524 103.302 75.2524V71.5948C106.298 69.74 106.177 65.81 106.177 65.81C105.962 64.6686 105.518 65.9657 105.518 65.9657C105.653 69.1564 103.222 70.5701 103.222 70.5701L103.087 63.2938L103.437 63.0992C105.196 58.845 104.766 55.8618 104.766 55.8618C104.323 53.9682 103.88 55.8618 103.88 55.8618C104.229 59.714 102.51 61.9579 102.51 61.9579C101.489 60.9332 101.14 58.0668 101.14 58.0668C101.099 56.7308 100.522 58.0668 100.522 58.0668C100.616 60.3495 102.187 63.19 102.187 63.19V68.6765L101.69 68.4171C100.629 67.4443 98.9907 61.5558 98.9907 61.5558C98.9101 60.6868 98.2654 61.5558 98.2654 61.5558C98.3057 63.0344 99.6623 66.8217 99.6623 66.8217L94.9075 65.3431C93.1614 64.5908 93.6718 65.3431 93.6718 65.3431L99.622 67.7296L100.898 68.7154L100.428 72.7621C100.213 74.7725 99.3668 74.7336 99.3668 74.7336L99.0713 70.7906C99.1519 69.0915 98.4803 70.2977 98.4803 70.2977C97.7953 71.7374 98.7758 76.0176 98.7758 76.0176C99.031 78.028 98.7355 80.2589 98.7355 80.2589C98.0102 81.4651 97.755 78.8581 97.755 78.8581C98.6012 72.6843 94.1822 70.2977 94.1822 70.2977L95.9686 72.7491C96.9491 74.967 96.7342 79.6234 96.7342 79.6234L93.1614 73.9813C93.1614 74.7725 94.6926 78.8711 94.6926 78.8711L90.8108 72.7621C91.7376 79.1305 99.4608 83.4626 99.4608 83.4626L98.843 89.2473C98.2654 87.3926 93.1077 84.4872 93.1077 84.4872L92.3555 80.635C91.6436 77.6389 89.1588 76.8996 89.1588 76.8996C92.0466 80.5183 91.9122 84.3575 91.9122 84.3575L88.0842 81.8413L88.6752 83.2032L91.4421 85.1487C95.0284 86.7181 97.2043 90.9205 97.2043 90.9205L98.6146 98.2098C99.5548 100.415 99.9041 104.721 99.9041 104.721C99.7295 106.511 96.5327 122.14 96.5327 122.14H107.842L107.023 116.187C108.138 114.189 109.051 112.257 109.051 112.257C109.051 109.507 105.639 108.002 105.639 108.002L105.962 102.127C106.23 99.4549 108.46 97.8207 108.46 97.8207L116.761 91.3744L122.617 87.1461C123.853 85.8621 125.438 86.0177 125.438 86.0177C126.902 86.0436 126.875 87.1461 126.875 87.1461C128.11 88.8712 129.104 92.9438 129.104 92.9438C129.4 94.6429 129.897 94.0723 129.897 94.0723L130.045 91.2707L130.662 91.4263L133.631 92.9179C134.665 93.6313 134.92 93.0476 134.92 93.0476L132.798 91.4263L136.331 91.6598C137.889 91.6079 136.895 91.0242 136.895 91.0242L130.716 90.6611C129.064 89.5586 128.245 86.9127 128.245 86.9127C132.422 87.7038 137.271 90.1682 137.271 90.1682C138.157 90.7778 139.151 90.3238 139.151 90.3238L135.766 88.3264C137.15 88.508 141.327 88.3783 141.327 88.3783C143.825 88.1189 141.65 87.8595 141.65 87.8595C140.038 87.9114 132.919 87.1461 132.919 87.1461L129.212 86.0696C132.153 86.5365 136.854 86.1474 136.854 86.1474C139.89 85.7324 136.908 85.3822 136.908 85.3822C134.141 86.0696 132.113 85.6935 132.113 85.6935C131.146 85.2784 126.969 85.1228 126.969 85.1228L126.378 84.7596C130.206 83.7868 137.432 84.578 137.432 84.578C139.084 84.3705 149.144 86.1993 149.144 86.1993C151.522 86.4328 149.494 85.3562 149.494 85.3562L142.67 84.4353C140.844 84.15 142.321 83.8906 142.321 83.8906L148.056 83.3199C149.709 83.0864 148.204 82.6584 148.204 82.6584L145.639 82.7622C143.96 82.7362 138.023 83.3977 138.023 83.3977L142.106 82.1137L140.548 82.0358L135.874 83.1124L134.168 83.0605V82.6714C136.546 82.6195 139.312 81.076 139.312 81.076L145.021 81.0242L148.459 81.1798C149.494 81.8932 155.605 82.7751 155.605 82.7751C157.311 82.6714 157.069 81.6208 157.069 81.6208C155.833 82.0618 154.329 81.3354 154.329 81.3354L155.618 80.648C157.378 80.2589 157.875 79.6363 157.875 79.6363ZM119.756 68.9877C120.575 69.0656 122.496 66.8347 122.496 66.8347L124.497 63.9812L122.644 67.989C121.932 69.299 119.555 70.5053 119.555 70.5053C119.555 70.5053 119.528 68.9618 119.756 68.9877ZM113.873 65.9397L117.782 62.6842L119.756 59.7529L118.426 63.19L116.814 66.2381L114.168 66.8477C114.168 66.8347 112.53 66.6012 113.873 65.9397ZM117.553 67.0163L115.055 70.7258L114.934 67.3665L117.553 67.0163ZM101.932 69.4287L102.644 69.74L102.375 70.4534L101.784 70.0902L101.932 69.4287ZM99.8235 81.9969C99.0041 83.0735 99.031 81.2836 99.031 81.2836L99.8906 79.6623V75.5766C101.476 75.2394 101.395 73.9813 101.395 73.9813V71.932C101.69 69.5714 102.255 71.6985 102.255 71.6985V77.4703C100.965 78.3523 99.8235 81.9969 99.8235 81.9969ZM106.083 76.3549L107.842 79.792C107.842 79.792 106.727 79.6623 106.66 79.5585C106.606 79.4548 104.713 77.3276 104.713 77.4055C104.713 77.4833 107.009 81.7116 107.009 81.7116L105.975 83.3069L104.242 82.0748L104.981 83.4885L103.396 85.1876C103.396 85.1876 102.658 86.2123 104.336 85.4211L105.666 84.4613L105.022 87.198C105.022 87.198 105.465 87.9373 105.841 87.1721L107.197 82.8659C107.197 82.8659 108.165 82.1007 108.111 82.9956C108.111 82.9956 108.554 83.9943 108.97 84.4483L108.944 88.0022C108.944 88.0022 102.765 94.4743 102.644 95.1099C102.644 95.1099 102.201 95.8751 102.201 94.9542C102.201 94.9542 101.113 90.6222 101.234 89.39L101.999 82.1266C101.999 82.1266 102.322 79.351 102.993 78.4301C102.993 78.4301 104.229 76.303 104.995 75.8879L107.842 74.098L109.279 73.9424L108.93 79.2991L106.365 75.4988C106.378 75.5118 105.935 75.7063 106.083 76.3549ZM107.291 73.9683L106.405 73.7867L110.193 70.609L112.516 69.2731L113.04 68.6635L112.369 68.0928L112.61 67.4832C112.61 67.4832 113.873 67.4573 113.873 67.4832V69.4547L109.749 72.5805L107.291 73.9683ZM110.381 77.7427V73.657L112.382 71.6596L114.383 70.8166V72.0228L111.643 77.7427C110.905 79.7401 110.381 77.7427 110.381 77.7427ZM115.377 87.639L111.67 90.4665V89.9996L112.382 80.1422C112.382 80.1422 115.847 76.6791 115.941 73.7738C115.941 73.7738 117.177 70.9722 118.265 70.2329L118.507 69.9605V78.6506C118.507 78.6506 117.123 82.412 116.801 84.7207C116.788 84.6947 116.519 86.6403 115.377 87.639ZM126.284 76.9385L129.467 73.7089C130.73 72.2173 138.936 67.4832 138.936 67.4832H139.353L139.205 67.7037C138.856 68.2484 134.679 72.4508 134.679 72.4508C133.591 73.657 127.291 76.9126 127.291 76.9126L125.733 77.7557L126.284 76.9385ZM121.704 85.0968V83.9165C121.704 83.9165 123.906 79.5066 126.942 78.0929L133.12 74.7336C133.12 74.7336 136.975 72.2433 137.795 72.0617C137.795 72.0617 141.556 70.5961 142.966 72.2173L144.699 73.683V74.3445C144.699 74.3445 136.371 78.3263 133.94 78.8062C133.94 78.8062 132.583 79.2213 133.967 78.3912C133.967 78.3912 138.856 74.6168 139.702 73.2031C139.702 73.2031 140.051 72.1006 138.789 73.0474C138.789 73.0474 136.317 76.277 132.489 77.8724C132.489 77.8724 125.397 81.984 123.463 83.696L121.704 85.0968ZM132.852 81.1279L126.23 83.6701L125.169 83.8776L125.438 83.4107C125.438 83.4107 131.294 79.6104 134.531 79.6623C134.531 79.6623 136.734 79.7401 137.714 78.4042L145.975 74.5001C145.975 74.5001 146.646 75.2654 148.647 75.6804C148.647 75.6804 148.997 75.9658 148.271 76.316C148.271 76.316 144.766 78.2874 140.951 79.0916C140.938 79.0786 134.934 81.0501 132.852 81.1279ZM153.523 81.3354L151.616 81.0501L153.523 80.9204V81.3354Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.884 40.8038C160.481 41.154 158.117 41.8155 158.117 41.8155L154.866 42.6715L152.959 43.2033H152.744C151.831 42.8531 150.944 43.0995 150.944 43.0995L150.649 42.892C148.07 41.3486 143.664 39.9089 143.664 39.9089C141.743 39.403 142.012 38.8583 142.012 38.8583V38.3524C142.16 38.6118 142.912 38.4951 142.912 38.4951C143.396 38.4302 143.516 38.106 143.516 38.106C142.428 37.9374 142.643 37.0554 142.643 37.0554H143.248L142.536 36.809C142.496 36.5625 142.603 35.7973 142.603 35.7973L143.624 36.0048C144.537 36.2902 143.892 35.5768 143.892 35.5768C143.073 34.63 141.985 29.8958 141.985 29.8958C141.878 29.4548 141.703 30.1422 141.703 30.1422C141.529 31.4393 139.259 34.4354 139.259 34.4354C138.506 34.8634 138.909 34.9672 138.909 34.9672L139.568 35.1747C139.272 35.9659 138.694 36.2253 138.694 36.2253C137.244 36.6144 135.686 37.4575 135.686 37.4575C135.122 38.1449 132.314 39.1047 132.314 39.1047C130.824 39.1825 128.527 40.4666 128.527 40.4666C127.345 40.9724 126.391 42.2565 126.391 42.2565L124.564 43.3071C124.081 43.5665 124.43 43.6184 124.43 43.6184L125.303 43.4497C125.76 43.4497 127.17 43.9815 127.17 43.9815C127.842 44.7079 128.782 44.0853 128.782 44.0853L130.541 43.1514C131.186 43.0736 131.253 43.3071 131.253 43.3071C131.723 43.9686 134.302 44.228 134.302 44.228C135.914 44.4744 137.244 43.6184 137.244 43.6184L139.85 42.4381L139.809 43.2941C139.796 43.6054 139.568 43.7481 139.568 43.7481C137.915 44.189 137.714 46.5626 137.714 46.5626L133.604 47.1852C133.268 47.1592 133.161 46.7572 133.161 46.7572C133.174 46.6404 133.013 45.8622 133.013 45.8622C132.449 44.6819 132.691 45.6158 132.691 45.6158C132.838 45.9789 132.704 46.3421 132.704 46.3421L131.858 46.9128L131.683 47.1203L130.112 46.8739C128.889 46.7312 125.478 46.1086 125.478 46.1086C124.349 45.8881 123.235 44.9543 123.141 44.8765C123.866 45.4731 123.826 46.8609 123.826 46.8609C124.349 47.717 124.121 51.8285 124.121 51.8285C123.812 52.2566 124.121 52.2176 124.121 52.2176C125.115 51.9712 128.003 50.5574 128.003 50.5574C129.561 50.1554 131.441 48.7935 131.441 48.7935C131.71 48.4303 132.019 48.2617 132.019 48.2617L132.368 48.3655C132.798 48.4433 132.691 49.2604 132.691 49.2604C132.744 49.9089 133.013 49.3253 133.013 49.3253C133.134 48.6508 133.322 47.704 133.322 47.704L137.633 47.0814C137.633 48.0282 138.251 48.7027 138.251 48.7027C138.6 48.9621 138.6 49.7014 138.6 49.7014C138.721 50.4667 139.218 50.311 139.218 50.311L139.715 49.6625C140.064 49.2734 140.306 49.5847 140.306 49.5847C140.897 49.7922 140.494 51.18 140.494 51.18L139.353 53.3331L138.332 53.3071C137.996 52.7365 138.063 53.3071 138.063 53.3071C138.171 54.0983 138.963 54.2799 138.963 54.2799C139.393 54.1632 139.138 54.682 139.138 54.682C138.936 55.2267 138.48 56.1217 138.48 56.1217C138.023 56.9388 138.587 56.6535 138.587 56.6535C138.99 56.3941 140.091 55.0322 140.091 55.0322C140.508 54.1632 141.488 53.2034 141.488 53.2034C142.025 52.944 143.234 51.3616 143.234 51.3616L145.88 47.7559C146.753 46.6145 146.552 45.2396 146.552 45.2396L152.26 43.9167L157.499 42.451C159.124 42.023 160.87 41.0892 160.87 41.0892C161.515 40.4925 160.884 40.8038 160.884 40.8038ZM150.864 43.8129H150.084C150.084 43.8129 149.252 43.5924 148.943 43.6054L144.873 41.5561C144.873 41.5561 144.349 41.1151 144.873 41.154L150.877 43.5924V43.8129H150.864Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4143 54.1505C18.4143 54.1505 19.8784 53.7095 20.2276 53.7744L22.3095 53.9041L22.5647 53.2815L22.3766 52.6459L21.6916 52.166C21.6916 52.166 21.4633 51.9326 22.0274 52.0752C22.0274 52.0752 22.7796 52.4773 22.9676 51.9715C22.9676 51.9715 23.1288 51.6213 23.2631 51.5954C23.2631 51.5954 23.6123 51.4916 23.4646 51.7899C23.4646 51.7899 23.2228 52.2698 23.5855 52.7238C23.5855 52.7238 23.975 53.3463 23.9347 53.6447C23.9347 53.6447 25.2779 52.179 26.3793 52.0882C26.3793 52.0882 27.7896 51.5046 28.0045 50.9728C28.0045 50.9728 27.709 52.3087 27.4135 52.6719C27.4135 52.6719 27.2926 52.8924 27.5344 52.8794C27.5344 52.8794 27.897 53.0091 27.5344 53.1258C27.5344 53.1258 27.024 53.1129 26.9434 53.5668L26.3658 54.3969L26.5539 55.253C26.5539 55.253 25.748 54.4099 25.3853 55.227L24.9152 55.6291C24.9152 55.6291 24.3511 55.9663 24.3914 55.6421C24.3914 55.6421 24.566 55.24 24.5257 55.0065C24.5257 55.0065 24.2974 54.825 24.163 55.1751C24.163 55.1751 24.069 56.1609 23.478 55.7588C23.478 55.7588 23.196 55.0714 22.9542 55.5124C22.9542 55.5124 22.1214 56.2776 21.9737 56.3944C21.9737 56.3944 21.6245 56.6278 21.5707 56.1868C21.5707 56.1868 21.5304 55.6032 20.9663 55.6291L19.9858 56.2128C19.9858 56.2128 19.5157 56.1609 19.9052 55.8366C19.9052 55.8366 20.1873 55.694 20.053 55.4345C20.053 55.4345 19.7978 55.2789 19.5963 55.3308L18.9113 55.655C18.9113 55.655 18.28 55.6291 18.9381 55.2659L19.3411 55.0454C19.3411 55.0454 19.9052 54.8509 19.3142 54.6304L18.28 54.358C18.2934 54.345 18.1322 54.2283 18.4143 54.1505Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4143 54.1505C18.4143 54.1505 19.8784 53.7095 20.2276 53.7744L22.3095 53.9041L22.5647 53.2815L22.3766 52.6459L21.6916 52.166C21.6916 52.166 21.4633 51.9326 22.0274 52.0752C22.0274 52.0752 22.7796 52.4773 22.9676 51.9715C22.9676 51.9715 23.1288 51.6213 23.2631 51.5954C23.2631 51.5954 23.6123 51.4916 23.4646 51.7899C23.4646 51.7899 23.2228 52.2698 23.5855 52.7238C23.5855 52.7238 23.975 53.3463 23.9347 53.6447C23.9347 53.6447 25.2779 52.179 26.3793 52.0882C26.3793 52.0882 27.7896 51.5046 28.0045 50.9728C28.0045 50.9728 27.709 52.3087 27.4135 52.6719C27.4135 52.6719 27.2926 52.8924 27.5344 52.8794C27.5344 52.8794 27.897 53.0091 27.5344 53.1258C27.5344 53.1258 27.024 53.1129 26.9434 53.5668L26.3658 54.3969L26.5539 55.253C26.5539 55.253 25.748 54.4099 25.3853 55.227L24.9152 55.6291C24.9152 55.6291 24.3511 55.9663 24.3914 55.6421C24.3914 55.6421 24.566 55.24 24.5257 55.0065C24.5257 55.0065 24.2974 54.825 24.163 55.1751C24.163 55.1751 24.069 56.1609 23.478 55.7588C23.478 55.7588 23.196 55.0714 22.9542 55.5124C22.9542 55.5124 22.1214 56.2776 21.9737 56.3944C21.9737 56.3944 21.6245 56.6278 21.5707 56.1868C21.5707 56.1868 21.5304 55.6032 20.9663 55.6291L19.9858 56.2128C19.9858 56.2128 19.5157 56.1609 19.9052 55.8366C19.9052 55.8366 20.1873 55.694 20.053 55.4345C20.053 55.4345 19.7978 55.2789 19.5963 55.3308L18.9113 55.655C18.9113 55.655 18.28 55.6291 18.9381 55.2659L19.3411 55.0454C19.3411 55.0454 19.9052 54.8509 19.3142 54.6304L18.28 54.358C18.2934 54.345 18.1322 54.2283 18.4143 54.1505Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9188 66.9518C19.9188 66.9518 20.9262 66.6535 21.1545 66.6924L22.5648 66.7702L22.7394 66.3552L22.6185 65.9402L22.1619 65.6289C22.1619 65.6289 22.0007 65.4732 22.3902 65.564C22.3902 65.564 22.9006 65.8234 23.0349 65.4862C23.0349 65.4862 23.1424 65.2527 23.2364 65.2268C23.2364 65.2268 23.4782 65.1619 23.3707 65.3565C23.3707 65.3565 23.1961 65.6807 23.4513 65.9661C23.4513 65.9661 23.7199 66.3682 23.6931 66.5627C23.6931 66.5627 24.6199 65.577 25.3586 65.5121C25.3586 65.5121 26.3257 65.1101 26.4734 64.7728C26.4734 64.7728 26.2585 65.6548 26.057 65.9012C26.057 65.9012 25.9764 66.0439 26.1376 66.0309C26.1376 66.0309 26.3794 66.1217 26.1376 66.1996C26.1376 66.1996 25.7884 66.1996 25.7347 66.4979L25.3317 67.0556L25.4526 67.6133C25.4526 67.6133 24.9019 67.0686 24.6601 67.6003L24.3378 67.8727C24.3378 67.8727 23.9617 68.0932 23.9751 67.8857C23.9751 67.8857 24.096 67.6133 24.0692 67.4706C24.0692 67.4706 23.908 67.3539 23.814 67.5874C23.814 67.5874 23.7468 68.2359 23.3438 67.9765C23.3438 67.9765 23.1558 67.5225 22.9946 67.8079C22.9946 67.8079 22.4171 68.3137 22.323 68.3915C22.323 68.3915 22.0813 68.5472 22.0544 68.2489C22.0544 68.2489 22.0275 67.8727 21.6515 67.8857L20.9799 68.2748C20.9799 68.2748 20.6575 68.2489 20.9262 68.0284C20.9262 68.0284 21.1142 67.9376 21.0202 67.756C21.0202 67.756 20.8456 67.6522 20.7112 67.6911L20.2411 67.9116C20.2411 67.9116 19.8113 67.8987 20.268 67.6522L20.5501 67.4966C20.5501 67.4966 20.9396 67.3669 20.5366 67.2242L19.8382 67.0556C19.8248 67.0815 19.7173 67.0037 19.9188 66.9518Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9188 66.9518C19.9188 66.9518 20.9262 66.6535 21.1545 66.6924L22.5648 66.7702L22.7394 66.3552L22.6185 65.9402L22.1619 65.6289C22.1619 65.6289 22.0007 65.4732 22.3902 65.564C22.3902 65.564 22.9006 65.8234 23.0349 65.4862C23.0349 65.4862 23.1424 65.2527 23.2364 65.2268C23.2364 65.2268 23.4782 65.1619 23.3707 65.3565C23.3707 65.3565 23.1961 65.6807 23.4513 65.9661C23.4513 65.9661 23.7199 66.3682 23.6931 66.5627C23.6931 66.5627 24.6199 65.577 25.3586 65.5121C25.3586 65.5121 26.3257 65.1101 26.4734 64.7728C26.4734 64.7728 26.2585 65.6548 26.057 65.9012C26.057 65.9012 25.9764 66.0439 26.1376 66.0309C26.1376 66.0309 26.3794 66.1217 26.1376 66.1996C26.1376 66.1996 25.7884 66.1996 25.7347 66.4979L25.3317 67.0556L25.4526 67.6133C25.4526 67.6133 24.9019 67.0686 24.6601 67.6003L24.3378 67.8727C24.3378 67.8727 23.9617 68.0932 23.9751 67.8857C23.9751 67.8857 24.096 67.6133 24.0692 67.4706C24.0692 67.4706 23.908 67.3539 23.814 67.5874C23.814 67.5874 23.7468 68.2359 23.3438 67.9765C23.3438 67.9765 23.1558 67.5225 22.9946 67.8079C22.9946 67.8079 22.4171 68.3137 22.323 68.3915C22.323 68.3915 22.0813 68.5472 22.0544 68.2489C22.0544 68.2489 22.0275 67.8727 21.6515 67.8857L20.9799 68.2748C20.9799 68.2748 20.6575 68.2489 20.9262 68.0284C20.9262 68.0284 21.1142 67.9376 21.0202 67.756C21.0202 67.756 20.8456 67.6522 20.7112 67.6911L20.2411 67.9116C20.2411 67.9116 19.8113 67.8987 20.268 67.6522L20.5501 67.4966C20.5501 67.4966 20.9396 67.3669 20.5366 67.2242L19.8382 67.0556C19.8248 67.0815 19.7173 67.0037 19.9188 66.9518Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6333 115.603L25.9227 115.914C25.9227 115.914 25.6272 111.025 26.4197 109.818C26.4197 109.831 24.2303 112.192 24.6333 115.603Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4135 115.525L28.4075 115.253C28.4075 115.253 28.206 111.414 28.609 111.024C28.609 111.024 27.1181 113.904 27.4135 115.525Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6831 117.302L17.5683 117.03C17.5683 117.03 17.7966 113.191 17.3399 112.802C17.3399 112.802 19.0189 115.668 18.6831 117.302Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.691 115.681L31.3895 115.408L31.4835 112.231C31.4835 112.231 30.3955 114.747 30.691 115.681Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1424 115.682C23.1424 115.682 23.1424 112.504 22.2425 111.726C22.2425 111.726 22.2425 114.709 21.947 115.293L23.1424 115.682Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7351 116.965C36.7351 116.965 36.7352 113.788 35.8352 113.009C35.8352 113.009 35.8352 115.993 35.5397 116.576L36.7351 116.965Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9045 116.187C28.9045 116.187 29.8044 113.904 32.1818 113.321C32.1818 113.321 29.6029 115.331 29.8984 116.498L28.9045 116.187Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8105 116.304C28.8105 116.304 29.7104 114.021 32.0878 113.438C32.0878 113.438 29.4955 115.461 29.8044 116.615L28.8105 116.304Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3196 115.577C27.3196 115.577 27.4136 112.827 25.3317 112.166C25.3317 112.166 26.7286 114.799 26.3257 116.122L27.3196 115.577Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9408 116.421C22.9408 116.421 22.6453 113.282 23.9347 111.998C23.9347 111.998 23.4378 116.226 23.9347 116.965L22.9408 116.421Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1546 115.124C21.1546 115.124 21.2486 112.958 20.6576 112.102C20.6576 112.102 20.5636 115.396 19.9591 116.33L21.1546 115.124Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8529 116.382C21.8529 116.382 21.3559 114.255 18.6696 113.321C18.6696 113.321 21.45 116.07 21.0604 116.965L21.8529 116.382Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3383 115.824C35.3383 115.824 34.8413 113.696 32.155 112.763C32.155 112.763 34.9353 115.512 34.5458 116.407L35.3383 115.824Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8862 116.148C31.8862 116.148 31.5907 115.292 33.0817 114.514C33.0817 114.514 32.3832 116.42 32.7862 117.03L31.8862 116.148Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2818 116.628C31.2818 116.628 31.2818 114.138 33.0279 113.217C33.0279 113.217 31.6847 116.395 32.1011 117.601L31.2818 116.628Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0397 115.876C20.0397 115.876 18.9786 112.399 18.4145 112.062C18.4145 112.062 19.1264 115.681 18.6831 116.368L20.0397 115.876Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8703 116.395C27.8703 116.395 28.5956 113.464 29.6164 112.62C29.6164 112.62 29.2 114.994 29.2 115.63L27.8703 116.395Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1354 116.55C33.1354 116.55 33.8607 113.619 34.8815 112.776C34.8815 112.776 34.4651 115.149 34.4651 115.785L33.1354 116.55Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8542 115.707C23.8542 115.707 24.9825 112.296 24.1632 111.167C24.1632 111.167 25.8153 114.54 24.9825 116.317L23.8542 115.707Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39647 115.785L0.107032 116.044C0.107032 116.044 0.402528 112.049 -0.389938 111.064C-0.389938 111.064 1.79942 112.996 1.39647 115.785Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48838 115.655L9.48232 115.305C9.48232 115.305 9.28085 110.402 9.6838 109.909C9.6838 109.909 8.19288 113.58 8.48838 115.655Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3333 117.419L8.44812 117.147C8.44812 117.147 8.21978 113.308 8.67646 112.919C8.67646 112.919 6.99751 115.798 7.3333 117.419Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7657 115.811L12.4641 115.538L12.5581 112.36C12.5716 112.36 11.4702 114.877 11.7657 115.811Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88741 115.811C2.88741 115.811 2.88741 112.633 3.78732 111.855C3.78732 111.855 3.78733 114.838 4.08282 115.422L2.88741 115.811Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8234 117.095C17.8234 117.095 17.8234 113.918 16.9235 113.139C16.9235 113.139 16.9235 116.123 16.628 116.706L17.8234 117.095Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97939 116.316C9.97939 116.316 10.8793 114.033 13.2567 113.45C13.2567 113.45 10.6778 115.473 10.9733 116.627L9.97939 116.316Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.28967 115.694C-1.28967 115.694 -1.38369 112.944 0.698213 112.283C0.698213 112.283 -0.698677 114.916 -0.295728 116.239L-1.28967 115.694Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08882 116.551C3.08882 116.551 3.38432 113.412 2.09488 112.128C2.09488 112.128 2.59185 116.356 2.09488 117.095L3.08882 116.551Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87524 115.253C4.87524 115.253 4.78122 113.074 5.37221 112.231C5.37221 112.231 5.46624 115.525 6.07066 116.459L4.87524 115.253Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4265 115.94C16.4265 115.94 15.9296 113.813 13.2432 112.879C13.2432 112.879 16.0236 115.629 15.6341 116.524L16.4265 115.94Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9611 116.278C12.9611 116.278 12.6656 115.422 14.1566 114.644C14.1566 114.644 13.4581 116.537 13.8611 117.16L12.9611 116.278Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3567 116.758C12.3567 116.758 12.3567 114.268 14.1028 113.347C14.1028 113.347 12.7597 116.525 13.176 117.731L12.3567 116.758Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99022 116.006C5.99022 116.006 7.05132 112.529 7.61544 112.192C7.61544 112.192 6.90357 115.811 7.34681 116.498L5.99022 116.006Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95851 116.524C8.95851 116.524 9.68382 113.593 10.7046 112.75C10.7046 112.75 10.2882 115.123 10.2882 115.759L8.95851 116.524Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 116.68C14.2103 116.68 14.9356 113.749 15.9564 112.906C15.9564 112.906 15.54 115.279 15.54 115.915L14.2103 116.68Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16209 115.837C2.16209 115.837 1.03383 112.426 1.85316 111.297C1.85316 111.297 0.201073 114.67 1.03383 116.447L2.16209 115.837Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30654 116.433C7.30654 116.433 6.40662 114.15 4.02922 113.567C4.02922 113.567 6.60809 115.577 6.3126 116.744L7.30654 116.433Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0149 116.511C13.0149 116.511 12.5179 114.384 9.8316 113.45C9.8316 113.45 12.612 116.199 12.2224 117.094L13.0149 116.511Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4624 115.382L51.7518 115.694C51.7518 115.694 51.4563 110.804 52.2488 109.598C52.2488 109.611 50.0594 111.971 50.4624 115.382Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2426 115.305L54.2365 115.033C54.2365 115.033 54.035 111.194 54.438 110.805C54.438 110.805 52.9471 113.684 53.2426 115.305Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5121 117.082L43.3973 116.809C43.3973 116.809 43.6256 112.97 43.1689 112.581C43.1689 112.581 44.8479 115.448 44.5121 117.082Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.52 115.461L57.2185 115.189L57.3125 112.011C57.3125 112.011 56.2245 114.527 56.52 115.461Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9714 115.461C48.9714 115.461 48.9714 112.283 48.0715 111.505C48.0715 111.505 48.0715 114.488 47.776 115.072L48.9714 115.461Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5642 116.745C62.5642 116.745 62.5642 113.567 61.6642 112.789C61.6642 112.789 61.6642 115.772 61.3687 116.356L62.5642 116.745Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7335 115.967C54.7335 115.967 55.6334 113.684 58.0108 113.1C58.0108 113.1 55.4319 115.11 55.7274 116.278L54.7335 115.967Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6395 116.083C54.6395 116.083 55.5394 113.801 57.9168 113.217C57.9168 113.217 55.3245 115.24 55.6334 116.395L54.6395 116.083Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1486 115.357C53.1486 115.357 53.2426 112.607 51.1607 111.945C51.1607 111.945 52.5576 114.578 52.1547 115.901L53.1486 115.357Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7698 116.2C48.7698 116.2 48.4743 113.061 49.7638 111.777C49.7638 111.777 49.2668 116.005 49.7638 116.745L48.7698 116.2Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9836 114.903C46.9836 114.903 47.0776 112.737 46.4866 111.881C46.4866 111.881 46.3926 115.175 45.7881 116.109L46.9836 114.903Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6819 116.161C47.6819 116.161 47.1849 114.034 44.4986 113.1C44.4986 113.1 47.2789 115.85 46.8894 116.745L47.6819 116.161Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1672 115.603C61.1672 115.603 60.6702 113.476 57.9839 112.542C57.9839 112.542 60.7642 115.292 60.3747 116.187L61.1672 115.603Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7153 115.927C57.7153 115.927 57.4198 115.071 58.9107 114.293C58.9107 114.293 58.2123 116.2 58.6152 116.809L57.7153 115.927Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1108 116.408C57.1108 116.408 57.1108 113.917 58.8569 112.996C58.8569 112.996 57.5137 116.174 57.9301 117.38L57.1108 116.408Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8687 115.655C45.8687 115.655 44.8076 112.179 44.2435 111.842C44.2435 111.842 44.9554 115.46 44.5121 116.148L45.8687 115.655Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6993 116.174C53.6993 116.174 54.4246 113.243 55.4454 112.4C55.4454 112.4 55.029 114.773 55.029 115.409L53.6993 116.174Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9646 116.329C58.9646 116.329 59.6899 113.398 60.7107 112.555C60.7107 112.555 60.2943 114.928 60.2943 115.564L58.9646 116.329Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6832 115.486C49.6832 115.486 50.8115 112.075 49.9922 110.947C49.9922 110.947 51.6442 114.319 50.8115 116.096L49.6832 115.486Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2254 115.564L25.936 115.824C25.936 115.824 26.2315 111.829 25.439 110.843C25.439 110.843 27.6284 112.776 27.2254 115.564Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3174 115.434L35.3113 115.084C35.3113 115.084 35.1098 110.181 35.5128 109.688C35.5128 109.688 34.0219 113.359 34.3174 115.434Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1623 117.199L34.2771 116.926C34.2771 116.926 34.0488 113.087 34.5055 112.698C34.5055 112.698 32.8265 115.577 33.1623 117.199Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5946 115.59L38.2931 115.318L38.3871 112.14C38.4005 112.14 37.2991 114.656 37.5946 115.59Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7166 115.59C28.7166 115.59 28.7166 112.412 29.6165 111.634C29.6165 111.634 29.6165 114.617 29.912 115.201L28.7166 115.59Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6524 116.875C43.6524 116.875 43.6524 113.697 42.7525 112.919C42.7525 112.919 42.7525 115.902 42.457 116.486L43.6524 116.875Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8084 116.096C35.8084 116.096 36.7083 113.814 39.0857 113.23C39.0857 113.23 36.5068 115.253 36.8023 116.408L35.8084 116.096Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5392 115.473C24.5392 115.473 24.4452 112.724 26.5271 112.062C26.5271 112.062 25.1302 114.695 25.5332 116.018L24.5392 115.473Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9178 116.33C28.9178 116.33 29.2133 113.191 27.9239 111.907C27.9239 111.907 28.4209 116.135 27.9239 116.875L28.9178 116.33Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7043 115.02C30.7043 115.02 30.6102 112.841 31.2012 111.998C31.2012 111.998 31.2952 115.292 31.8997 116.226L30.7043 115.02Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2555 115.72C42.2555 115.72 41.7585 113.593 39.0722 112.659C39.0722 112.659 41.8525 115.409 41.463 116.303L42.2555 115.72Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7902 116.057C38.7902 116.057 38.4947 115.201 39.9856 114.423C39.9856 114.423 39.2871 116.317 39.6901 116.939L38.7902 116.057Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1857 116.537C38.1857 116.537 38.1857 114.047 39.9318 113.126C39.9318 113.126 38.5886 116.304 39.005 117.51L38.1857 116.537Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8192 115.785C31.8192 115.785 32.8803 112.309 33.4444 111.972C33.4444 111.972 32.7325 115.59 33.1758 116.278L31.8192 115.785Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7875 116.291C34.7875 116.291 35.5128 113.36 36.5336 112.517C36.5336 112.517 36.1172 114.89 36.1172 115.526L34.7875 116.291Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0392 116.459C40.0392 116.459 40.7646 113.528 41.7854 112.685C41.7854 112.685 41.369 115.058 41.369 115.694L40.0392 116.459Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9911 115.616C27.9911 115.616 26.8628 112.205 27.6821 111.077C27.6821 111.077 26.0301 114.449 26.8628 116.226L27.9911 115.616Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1354 116.213C33.1354 116.213 32.2355 113.931 29.8581 113.347C29.8581 113.347 32.437 115.357 32.1415 116.525L33.1354 116.213Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.844 116.291C38.844 116.291 38.347 114.164 35.6607 113.23C35.6607 113.23 38.441 115.98 38.0515 116.875L38.844 116.291Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2913 115.163L77.5807 115.474C77.5807 115.474 77.2852 110.584 78.0777 109.378C78.0777 109.378 75.8883 111.751 76.2913 115.163Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0715 115.085L80.0655 114.812C80.0655 114.812 79.864 110.973 80.267 110.584C80.267 110.584 78.776 113.451 79.0715 115.085Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3411 116.848L69.2262 116.576C69.2262 116.576 69.4546 112.737 68.9979 112.347C68.9979 112.36 70.6769 115.227 70.3411 116.848Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3489 115.24L83.0473 114.968L83.1413 111.79C83.1413 111.79 82.0534 114.306 82.3489 115.24Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8004 115.24C74.8004 115.24 74.8004 112.063 73.9004 111.284C73.9004 111.284 73.9004 114.268 73.6049 114.851L74.8004 115.24Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.393 116.524C88.393 116.524 88.393 113.346 87.4931 112.568C87.4931 112.568 87.4931 115.551 87.1976 116.135L88.393 116.524Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5626 115.746C80.5626 115.746 81.4625 113.463 83.8399 112.879C83.8399 112.879 81.261 114.89 81.5565 116.057L80.5626 115.746Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4685 115.863C80.4685 115.863 81.3684 113.58 83.7458 112.996C83.7458 112.996 81.1535 115.02 81.4624 116.174L80.4685 115.863Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9776 115.137C78.9776 115.137 79.0716 112.387 76.9897 111.726C76.9897 111.726 78.3866 114.359 77.9837 115.682L78.9776 115.137Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5989 115.979C74.5989 115.979 74.3034 112.84 75.5929 111.556C75.5929 111.556 75.0959 115.785 75.5929 116.524L74.5989 115.979Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.8124 114.682C72.8124 114.682 72.9064 112.516 72.3154 111.66C72.3154 111.66 72.2214 114.955 71.617 115.889L72.8124 114.682Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5109 115.94C73.5109 115.94 73.0139 113.813 70.3276 112.879C70.3276 112.879 73.108 115.629 72.7184 116.524L73.5109 115.94Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9961 115.37C86.9961 115.37 86.4992 113.243 83.8128 112.309C83.8128 112.309 86.5932 115.059 86.2037 115.954L86.9961 115.37Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5443 115.707C83.5443 115.707 83.2488 114.851 84.7397 114.072C84.7397 114.072 84.0413 115.979 84.4442 116.589L83.5443 115.707Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.94 116.187C82.94 116.187 82.94 113.697 84.6861 112.776C84.6861 112.776 83.3429 115.953 83.7593 117.16L82.94 116.187Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6976 115.434C71.6976 115.434 70.6365 111.958 70.0724 111.621C70.0724 111.621 70.7843 115.24 70.341 115.927L71.6976 115.434Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5283 115.954C79.5283 115.954 80.2536 113.022 81.2744 112.179C81.2744 112.179 80.858 114.553 80.858 115.188L79.5283 115.954Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7935 116.109C84.7935 116.109 85.5189 113.177 86.5397 112.334C86.5397 112.334 86.1233 114.708 86.1233 115.343L84.7935 116.109Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5121 115.266C75.5121 115.266 76.6404 111.855 75.821 110.726C75.821 110.726 77.4731 114.098 76.6404 115.875L75.5121 115.266Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0544 115.344L51.765 115.603C51.765 115.603 52.0605 111.608 51.268 110.622C51.268 110.622 53.4574 112.555 53.0544 115.344Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1465 115.214L61.1404 114.864C61.1404 114.864 60.9389 109.961 61.3419 109.469C61.3419 109.469 59.851 113.139 60.1465 115.214Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9913 116.978L60.1061 116.706C60.1061 116.706 59.8778 112.867 60.3344 112.477C60.3344 112.477 58.6555 115.357 58.9913 116.978Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4238 115.37L64.1222 115.098L64.2162 111.92C64.2297 111.92 63.1283 114.436 63.4238 115.37Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5455 115.37C54.5455 115.37 54.5455 112.193 55.4454 111.414C55.4454 111.414 55.4454 114.397 55.7409 114.981L54.5455 115.37Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4814 116.654C69.4814 116.654 69.4814 113.476 68.5815 112.698C68.5815 112.698 68.5815 115.681 68.286 116.265L69.4814 116.654Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6374 115.876C61.6374 115.876 62.5373 113.593 64.9147 113.009C64.9147 113.009 62.3358 115.033 62.6313 116.187L61.6374 115.876Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3682 115.253C50.3682 115.253 50.2742 112.503 52.3561 111.842C52.3561 111.842 50.9592 114.475 51.3621 115.797L50.3682 115.253Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.747 116.109C54.747 116.109 55.0425 112.97 53.7531 111.686C53.7531 111.686 54.2501 115.915 53.7531 116.654L54.747 116.109Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5333 114.799C56.5333 114.799 56.4393 112.62 57.0303 111.777C57.0303 111.777 57.1243 115.072 57.7288 116.005L56.5333 114.799Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0845 115.499C68.0845 115.499 67.5875 113.372 64.9012 112.438C64.9012 112.438 67.6816 115.188 67.292 116.083L68.0845 115.499Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6192 115.837C64.6192 115.837 64.3238 114.981 65.8147 114.202C65.8147 114.202 65.1162 116.096 65.5192 116.719L64.6192 115.837Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0147 116.317C64.0147 116.317 64.0147 113.827 65.7608 112.906C65.7608 112.906 64.4176 116.083 64.834 117.29L64.0147 116.317Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6482 115.564C57.6482 115.564 58.7093 112.088 59.2734 111.751C59.2734 111.751 58.5615 115.37 59.0048 116.057L57.6482 115.564Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6165 116.07C60.6165 116.07 61.3418 113.139 62.3626 112.296C62.3626 112.296 61.9462 114.67 61.9462 115.305L60.6165 116.07Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8683 116.239C65.8683 116.239 66.5936 113.307 67.6144 112.464C67.6144 112.464 67.198 114.838 67.198 115.473L65.8683 116.239Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8201 115.396C53.8201 115.396 52.6918 111.985 53.5112 110.856C53.5112 110.856 51.8591 114.228 52.6918 116.005L53.8201 115.396Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9644 115.993C58.9644 115.993 58.0645 113.71 55.6871 113.126C55.6871 113.126 58.266 115.137 57.9705 116.304L58.9644 115.993Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.673 116.07C64.673 116.07 64.176 113.943 61.4897 113.009C61.4897 113.009 64.27 115.759 63.8805 116.654L64.673 116.07Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.12 114.942L103.41 115.253C103.41 115.253 103.114 110.364 103.907 109.157C103.907 109.157 101.717 111.531 102.12 114.942Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.901 114.864L105.894 114.592C105.894 114.592 105.693 110.753 106.096 110.363C106.096 110.363 104.605 113.23 104.901 114.864Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.1701 116.628L95.0552 116.356C95.0552 116.356 95.2836 112.517 94.8269 112.128C94.8269 112.128 96.5059 115.007 96.1701 116.628Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.178 115.02L108.876 114.747L108.97 111.57C108.97 111.57 107.882 114.086 108.178 115.02Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.629 115.02C100.629 115.02 100.629 111.842 99.7295 111.064C99.7295 111.064 99.7295 114.047 99.4341 114.631L100.629 115.02Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.222 116.303C114.222 116.303 114.222 113.126 113.322 112.347C113.322 112.347 113.322 115.331 113.027 115.914L114.222 116.303Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.392 115.525C106.392 115.525 107.291 113.242 109.669 112.659C109.669 112.659 107.09 114.669 107.386 115.837L106.392 115.525Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.298 115.642C106.298 115.642 107.197 113.359 109.575 112.776C109.575 112.776 106.983 114.799 107.292 115.953L106.298 115.642Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.807 114.903C104.807 114.903 104.901 112.153 102.819 111.492C102.819 111.492 104.216 114.125 103.813 115.448L104.807 114.903Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.428 115.759C100.428 115.759 100.132 112.62 101.422 111.336C101.422 111.336 100.925 115.564 101.422 116.303L100.428 115.759Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6414 114.462C98.6414 114.462 98.7355 112.296 98.1445 111.44C98.1445 111.44 98.0504 114.734 97.446 115.668L98.6414 114.462Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.34 115.72C99.34 115.72 98.843 113.593 96.1567 112.659C96.1567 112.659 98.9371 115.409 98.5475 116.303L99.34 115.72Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.825 115.149C112.825 115.149 112.328 113.022 109.642 112.089C109.642 112.089 112.422 114.838 112.033 115.733L112.825 115.149Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.373 115.487C109.373 115.487 109.078 114.631 110.569 113.853C110.569 113.853 109.87 115.759 110.273 116.369L109.373 115.487Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.769 115.966C108.769 115.966 108.769 113.476 110.515 112.555C110.515 112.555 109.172 115.733 109.588 116.939L108.769 115.966Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5266 115.214C97.5266 115.214 96.4655 111.738 95.9014 111.401C95.9014 111.401 96.6132 115.02 96.17 115.707L97.5266 115.214Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.357 115.733C105.357 115.733 106.083 112.802 107.103 111.958C107.103 111.958 106.687 114.332 106.687 114.968L105.357 115.733Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.623 115.889C110.623 115.889 111.348 112.958 112.369 112.115C112.369 112.115 111.952 114.488 111.952 115.124L110.623 115.889Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.341 115.046C101.341 115.046 102.469 111.635 101.65 110.506C101.65 110.506 103.302 113.879 102.469 115.656L101.341 115.046Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8835 115.123L77.5941 115.382C77.5941 115.382 77.8896 111.387 77.0971 110.402C77.0971 110.402 79.2865 112.334 78.8835 115.123Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9755 114.994L86.9694 114.644C86.9694 114.644 86.7679 109.741 87.1709 109.248C87.1709 109.248 85.68 112.906 85.9755 114.994Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8204 116.757L85.9352 116.485C85.9352 116.485 85.7069 112.646 86.1636 112.257C86.1636 112.257 84.4846 115.123 84.8204 116.757Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2528 115.15L89.9513 114.877L90.0453 111.7C90.0587 111.687 88.9573 114.216 89.2528 115.15Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3745 115.15C80.3745 115.15 80.3745 111.972 81.2744 111.194C81.2744 111.194 81.2744 114.177 81.5699 114.761L80.3745 115.15Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3103 116.433C95.3103 116.433 95.3103 113.256 94.4104 112.477C94.4104 112.477 94.4104 115.461 94.1149 116.044L95.3103 116.433Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4664 115.655C87.4664 115.655 88.3663 113.372 90.7437 112.789C90.7437 112.789 88.1648 114.812 88.4603 115.966L87.4664 115.655Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1972 115.032C76.1972 115.032 76.1032 112.282 78.1851 111.621C78.1851 111.621 76.7882 114.254 77.1911 115.577L76.1972 115.032Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5759 115.876C80.5759 115.876 80.8714 112.737 79.582 111.453C79.582 111.453 80.0789 115.681 79.582 116.42L80.5759 115.876Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3624 114.578C82.3624 114.578 82.2684 112.399 82.8594 111.556C82.8594 111.556 82.9534 114.851 83.5579 115.785L82.3624 114.578Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9135 115.279C93.9135 115.279 93.4165 113.152 90.7302 112.218C90.7302 112.218 93.5105 114.968 93.121 115.863L93.9135 115.279Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4483 115.616C90.4483 115.616 90.1528 114.76 91.6437 113.982C91.6437 113.982 90.9452 115.875 91.3482 116.498L90.4483 115.616Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8438 116.096C89.8438 116.096 89.8438 113.606 91.5899 112.685C91.5899 112.685 90.2468 115.863 90.6631 117.069L89.8438 116.096Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4772 115.344C83.4772 115.344 84.5383 111.868 85.1024 111.53C85.1024 111.53 84.3905 115.149 84.8338 115.836L83.4772 115.344Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4455 115.85C86.4455 115.85 87.1708 112.918 88.1916 112.075C88.1916 112.075 87.7752 114.449 87.7752 115.084L86.4455 115.85Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6975 116.018C91.6975 116.018 92.4228 113.087 93.4436 112.244C93.4436 112.244 93.0272 114.617 93.0272 115.253L91.6975 116.018Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6492 115.175C79.6492 115.175 78.5209 111.764 79.3403 110.635C79.3403 110.635 77.6882 114.008 78.5209 115.785L79.6492 115.175Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7934 115.772C84.7934 115.772 83.8935 113.489 81.5161 112.906C81.5161 112.906 84.095 114.916 83.7995 116.083L84.7934 115.772Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.502 115.837C90.502 115.837 90.005 113.709 87.3187 112.776C87.3187 112.776 90.099 115.525 89.7095 116.42L90.502 115.837Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.842 115.811L129.131 116.122C129.131 116.122 128.836 111.232 129.628 110.026C129.642 110.026 127.452 112.386 127.842 115.811Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.636 115.733L131.63 115.46C131.63 115.46 131.428 111.621 131.831 111.232C131.818 111.232 130.327 114.098 130.636 115.733Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.905 117.497L120.79 117.225C120.79 117.225 121.019 113.385 120.562 112.996C120.562 112.996 122.241 115.863 121.905 117.497Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.913 115.888L134.611 115.616L134.705 112.438C134.705 112.425 133.618 114.954 133.913 115.888Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.351 115.888C126.351 115.888 126.351 112.71 125.451 111.932C125.451 111.932 125.451 114.915 125.155 115.499L126.351 115.888Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.957 117.173C139.957 117.173 139.957 113.995 139.057 113.217C139.057 113.217 139.057 116.2 138.762 116.784L139.957 117.173Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.127 116.382C132.127 116.382 133.027 114.099 135.404 113.515C135.404 113.515 132.825 115.526 133.121 116.693L132.127 116.382Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.019 116.512C132.019 116.512 132.919 114.229 135.296 113.645C135.296 113.645 132.704 115.668 133.013 116.823L132.019 116.512Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.528 115.772C130.528 115.772 130.622 113.022 128.54 112.36C128.54 112.36 129.937 114.993 129.534 116.316L130.528 115.772Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.163 116.615C126.163 116.615 125.867 113.476 127.157 112.192C127.157 112.192 126.66 116.421 127.157 117.16L126.163 116.615Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.363 115.318C124.363 115.318 124.457 113.152 123.866 112.296C123.866 112.296 123.772 115.59 123.168 116.524L124.363 115.318Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.061 116.576C125.061 116.576 124.564 114.449 121.878 113.515C121.878 113.515 124.658 116.265 124.269 117.16L125.061 116.576Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.56 116.018C138.56 116.018 138.063 113.891 135.377 112.957C135.377 112.957 138.157 115.707 137.768 116.602L138.56 116.018Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.108 116.343C135.108 116.343 134.813 115.486 136.304 114.708C136.304 114.708 135.605 116.615 136.008 117.224L135.108 116.343Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.491 116.836C134.491 116.836 134.491 114.345 136.237 113.425C136.237 113.425 134.893 116.602 135.31 117.809L134.491 116.836Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.262 116.07C123.262 116.07 122.201 112.594 121.636 112.257C121.636 112.257 122.348 115.875 121.905 116.563L123.262 116.07Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.092 116.589C131.092 116.589 131.818 113.658 132.838 112.815C132.838 112.815 132.422 115.189 132.422 115.824L131.092 116.589Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.344 116.758C136.344 116.758 137.069 113.826 138.09 112.983C138.09 112.983 137.674 115.357 137.674 115.992L136.344 116.758Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.076 115.915C127.076 115.915 128.205 112.504 127.385 111.375C127.385 111.375 129.037 114.747 128.205 116.524L127.076 115.915Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.619 115.992L103.329 116.252C103.329 116.252 103.625 112.257 102.832 111.271C102.819 111.258 105.008 113.204 104.619 115.992Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask226_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask226_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.711 115.849L112.705 115.499C112.705 115.499 112.503 110.596 112.906 110.104C112.906 110.116 111.415 113.774 111.711 115.849Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask227_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask227_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.555 117.627L111.67 117.355C111.67 117.355 111.442 113.515 111.898 113.126C111.898 113.126 110.22 115.993 110.555 117.627Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask228_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask228_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.988 116.005L115.686 115.733L115.78 112.555C115.78 112.555 114.692 115.071 114.988 116.005Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask229_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask229_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.109 116.005C106.109 116.005 106.109 112.827 107.009 112.049C107.009 112.049 107.009 115.032 107.305 115.616L106.109 116.005Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask230_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask230_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.032 117.29C121.032 117.29 121.032 114.112 120.132 113.334C120.132 113.334 120.132 116.317 119.837 116.901L121.032 117.29Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask231_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask231_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.201 116.512C113.201 116.512 114.101 114.229 116.479 113.645C116.479 113.645 113.9 115.668 114.195 116.823L113.201 116.512Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask232_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask232_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.932 115.902C101.932 115.902 101.838 113.152 103.92 112.49C103.92 112.49 102.523 115.123 102.926 116.446L101.932 115.902Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask233_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask233_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.298 116.745C106.298 116.745 106.593 113.606 105.304 112.322C105.304 112.322 105.801 116.55 105.304 117.29L106.298 116.745Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask234_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask234_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.097 115.448C108.097 115.448 108.003 113.269 108.594 112.426C108.594 112.426 108.688 115.72 109.293 116.654L108.097 115.448Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask235_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask235_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.635 116.148C119.635 116.148 119.138 114.021 116.452 113.087C116.452 113.087 119.232 115.837 118.843 116.732L119.635 116.148Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask236_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask236_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.183 116.472C116.183 116.472 115.888 115.616 117.379 114.838C117.379 114.838 116.68 116.732 117.083 117.354L116.183 116.472Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask237_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask237_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.565 116.953C115.565 116.953 115.565 114.462 117.311 113.541C117.311 113.541 115.968 116.719 116.385 117.925L115.565 116.953Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask238_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask238_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.199 116.2C109.199 116.2 110.26 112.724 110.824 112.387C110.824 112.387 110.112 116.005 110.555 116.693L109.199 116.2Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask239_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask239_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.167 116.718C112.167 116.718 112.892 113.787 113.913 112.944C113.913 112.944 113.497 115.318 113.497 115.953L112.167 116.718Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask240_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask240_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.419 116.874C117.419 116.874 118.144 113.943 119.165 113.1C119.165 113.1 118.749 115.474 118.749 116.109L117.419 116.874Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask241_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask241_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.384 116.032C105.384 116.032 104.256 112.62 105.075 111.492C105.075 111.492 103.423 114.864 104.256 116.641L105.384 116.032Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask242_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask242_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.529 116.628C110.529 116.628 109.629 114.345 107.251 113.761C107.251 113.761 109.83 115.771 109.535 116.939L110.529 116.628Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask243_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask243_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.224 116.706C116.224 116.706 115.727 114.579 113.04 113.645C113.04 113.645 115.821 116.395 115.431 117.29L116.224 116.706Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask244_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask244_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.089 115.435L157.378 115.746C157.378 115.746 157.083 110.856 157.875 109.65C157.875 109.65 155.699 112.011 156.089 115.435Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask245_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask245_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.869 115.357L159.863 115.085C159.863 115.085 159.661 111.245 160.064 110.856C160.064 110.856 158.573 113.723 158.869 115.357Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask246_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask246_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.152 117.121L149.037 116.849C149.037 116.849 149.265 113.01 148.809 112.62C148.809 112.62 150.488 115.487 150.152 117.121Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask247_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask247_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.16 115.512L162.858 115.24L162.952 112.062C162.952 112.049 161.851 114.579 162.16 115.512Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask248_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask248_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.598 115.512C154.598 115.512 154.598 112.335 153.698 111.556C153.698 111.556 153.698 114.54 153.402 115.123L154.598 115.512Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask249_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask249_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.36 116.018C160.36 116.018 161.26 113.735 163.637 113.151C163.637 113.151 161.058 115.162 161.354 116.329L160.36 116.018Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask250_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask250_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.266 116.135C160.266 116.135 161.166 113.852 163.543 113.268C163.543 113.268 160.951 115.292 161.26 116.446L160.266 116.135Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask251_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask251_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.775 115.396C158.775 115.396 158.869 112.646 156.787 111.985C156.787 111.985 158.184 114.618 157.781 115.941L158.775 115.396Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask252_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask252_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.396 116.239C154.396 116.239 154.101 113.1 155.39 111.816C155.39 111.816 154.893 116.045 155.39 116.784L154.396 116.239Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask253_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask253_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.61 114.942C152.61 114.942 152.704 112.776 152.113 111.92C152.113 111.92 152.019 115.215 151.414 116.148L152.61 114.942Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask254_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask254_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.308 116.2C153.308 116.2 152.811 114.073 150.125 113.139C150.125 113.139 152.905 115.889 152.516 116.784L153.308 116.2Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask255_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask255_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.737 116.459C162.737 116.459 162.737 113.969 164.483 113.048C164.483 113.048 163.14 116.225 163.557 117.432L162.737 116.459Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask256_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask256_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.495 115.707C151.495 115.707 150.434 112.231 149.87 111.894C149.87 111.894 150.582 115.513 150.138 116.2L151.495 115.707Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask257_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask257_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.339 116.212C159.339 116.212 160.064 113.281 161.085 112.438C161.085 112.438 160.669 114.812 160.669 115.447L159.339 116.212Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask258_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask258_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.323 115.539C155.323 115.539 156.451 112.128 155.632 110.999C155.632 110.999 157.284 114.372 156.451 116.148L155.323 115.539Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask259_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask259_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.852 115.617L131.562 115.876C131.562 115.876 131.858 111.881 131.065 110.895C131.065 110.895 133.255 112.828 132.852 115.617Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask260_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask260_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.957 115.473L140.951 115.123C140.951 115.123 140.75 110.221 141.153 109.728C141.139 109.741 139.648 113.398 139.957 115.473Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask261_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask261_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.802 117.25L139.917 116.978C139.917 116.978 139.688 113.139 140.145 112.75C140.145 112.75 138.466 115.616 138.802 117.25Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask262_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask262_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.234 115.629L143.933 115.357L144.027 112.179C144.027 112.179 142.939 114.708 143.234 115.629Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask263_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask263_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.343 115.629C134.343 115.629 134.343 112.452 135.243 111.673C135.243 111.673 135.243 114.657 135.538 115.24L134.343 115.629Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask264_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask264_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.279 116.926C149.279 116.926 149.279 113.748 148.379 112.97C148.379 112.97 148.379 115.953 148.083 116.537L149.279 116.926Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask265_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask265_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.448 116.135C141.448 116.135 142.348 113.852 144.725 113.268C144.725 113.268 142.147 115.292 142.442 116.446L141.448 116.135Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask266_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask266_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.165 115.526C130.165 115.526 130.071 112.776 132.153 112.115C132.153 112.115 130.756 114.748 131.159 116.071L130.165 115.526Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask267_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask267_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.544 116.368C134.544 116.368 134.84 113.229 133.55 111.945C133.55 111.945 134.047 116.174 133.55 116.913L134.544 116.368Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask268_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask268_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.344 115.071C136.344 115.071 136.25 112.892 136.841 112.049C136.841 112.049 136.935 115.344 137.539 116.277L136.344 115.071Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask269_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask269_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.882 115.772C147.882 115.772 147.385 113.645 144.699 112.711C144.699 112.711 147.479 115.461 147.089 116.356L147.882 115.772Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask270_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask270_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.43 116.097C144.43 116.097 144.134 115.24 145.625 114.462C145.625 114.462 144.927 116.356 145.33 116.979L144.43 116.097Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask271_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask271_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.812 116.589C143.812 116.589 143.812 114.099 145.558 113.178C145.558 113.178 144.215 116.355 144.631 117.562L143.812 116.589Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask272_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask272_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.445 115.824C137.445 115.824 138.507 112.348 139.071 112.011C139.071 112.011 138.359 115.63 138.802 116.317L137.445 115.824Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask273_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask273_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.414 116.342C140.414 116.342 141.139 113.411 142.16 112.568C142.16 112.568 141.744 114.942 141.744 115.577L140.414 116.342Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask274_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask274_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.666 116.499C145.666 116.499 146.391 113.567 147.412 112.724C147.412 112.724 146.995 115.098 146.995 115.733L145.666 116.499Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask275_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask275_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.631 115.655C133.631 115.655 132.503 112.244 133.322 111.115C133.322 111.115 131.67 114.487 132.503 116.264L133.631 115.655Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask276_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask276_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.775 116.265C138.775 116.265 137.875 113.982 135.498 113.398C135.498 113.398 138.077 115.409 137.781 116.576L138.775 116.265Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask277_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask277_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.47 116.329C144.47 116.329 143.973 114.202 141.287 113.268C141.287 113.268 144.067 116.018 143.678 116.913L144.47 116.329Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask278_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask278_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7581 115.967L32.0475 116.278C32.0475 116.278 31.752 111.388 32.5445 110.182C32.5579 110.182 30.3686 112.556 30.7581 115.967Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask279_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask279_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5519 115.889L34.5459 115.616C34.5459 115.616 34.3444 111.777 34.7473 111.388C34.7339 111.388 33.243 114.255 33.5519 115.889Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask280_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask280_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8213 117.652L23.7065 117.38C23.7065 117.38 23.9349 113.541 23.4782 113.151C23.4782 113.151 25.1571 116.031 24.8213 117.652Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask281_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask281_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8293 116.044L37.5277 115.772L37.6217 112.594C37.6217 112.594 36.5338 115.11 36.8293 116.044Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask282_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask282_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2671 116.044C29.2671 116.044 29.2671 112.867 28.3672 112.089C28.3672 112.089 28.3672 115.072 28.0717 115.655L29.2671 116.044Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask283_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask283_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8734 117.328C42.8734 117.328 42.8734 114.15 41.9735 113.372C41.9735 113.372 41.9735 116.355 41.678 116.939L42.8734 117.328Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask284_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask284_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0427 116.55C35.0427 116.55 35.9426 114.267 38.32 113.683C38.32 113.683 35.7412 115.694 36.0367 116.861L35.0427 116.55Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask285_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask285_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9353 116.667C34.9353 116.667 35.8352 114.384 38.2126 113.8C38.2126 113.8 35.6203 115.824 35.9292 116.978L34.9353 116.667Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask286_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask286_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4442 115.928C33.4442 115.928 33.5382 113.178 31.4563 112.517C31.4563 112.517 32.8532 115.15 32.4503 116.473L33.4442 115.928Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask287_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask287_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0791 116.783C29.0791 116.783 28.7836 113.645 30.073 112.36C30.073 112.36 29.576 116.589 30.073 117.328L29.0791 116.783Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask288_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask288_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2792 115.473C27.2792 115.473 27.3732 113.307 26.7822 112.451C26.7822 112.451 26.6882 115.746 26.0837 116.679L27.2792 115.473Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask289_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask289_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9777 116.744C27.9777 116.744 27.4808 114.617 24.7944 113.683C24.7944 113.683 27.5748 116.433 27.1853 117.328L27.9777 116.744Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask290_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask290_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4765 116.174C41.4765 116.174 40.9796 114.047 38.2932 113.113C38.2932 113.113 41.0736 115.863 40.6841 116.758L41.4765 116.174Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask291_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask291_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0245 116.511C38.0245 116.511 37.729 115.655 39.2199 114.876C39.2199 114.876 38.5215 116.783 38.9244 117.393L38.0245 116.511Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask292_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask292_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4067 116.991C37.4067 116.991 37.4067 114.501 39.1529 113.58C39.1529 113.58 37.8097 116.757 38.2261 117.964L37.4067 116.991Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask293_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask293_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1779 116.239C26.1779 116.239 25.1168 112.763 24.5526 112.426C24.5526 112.426 25.2645 116.045 24.8213 116.732L26.1779 116.239Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask294_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask294_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0084 116.758C34.0084 116.758 34.7337 113.826 35.7545 112.983C35.7545 112.983 35.3382 115.357 35.3382 115.992L34.0084 116.758Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask295_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask295_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2603 116.914C39.2603 116.914 39.9856 113.982 41.0064 113.139C41.0064 113.139 40.59 115.513 40.59 116.149L39.2603 116.914Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask296_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask296_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9925 116.07C29.9925 116.07 31.1207 112.659 30.3014 111.53C30.3014 111.53 31.9535 114.903 31.1207 116.679L29.9925 116.07Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask297_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask297_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53477 116.148L6.24534 116.407C6.24534 116.407 6.54083 112.412 5.74837 111.427C5.73494 111.427 7.92429 113.359 7.53477 116.148Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask298_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask298_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6267 116.019L15.6207 115.668C15.6207 115.668 15.4192 110.766 15.8221 110.273C15.8221 110.273 14.3312 113.93 14.6267 116.019Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask299_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask299_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4714 117.782L14.5863 117.51C14.5863 117.51 14.3579 113.671 14.8146 113.281C14.8146 113.281 13.1356 116.148 13.4714 117.782Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask300_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask300_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9039 116.174L18.6023 115.902L18.6963 112.724C18.6963 112.711 17.6084 115.241 17.9039 116.174Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask301_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask301_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02554 116.174C9.02554 116.174 9.02554 112.997 9.92546 112.218C9.92546 112.218 9.92546 115.202 10.221 115.785L9.02554 116.174Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask302_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask302_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9482 117.458C23.9482 117.458 23.9482 114.28 23.0483 113.502C23.0483 113.502 23.0483 116.485 22.7528 117.069L23.9482 117.458Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask303_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask303_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1178 116.667C16.1178 116.667 17.0177 114.384 19.3951 113.8C19.3951 113.8 16.8162 115.824 17.1117 116.978L16.1178 116.667Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask304_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask304_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84858 116.057C4.84858 116.057 4.75455 113.307 6.83646 112.646C6.83646 112.646 5.43957 115.279 5.84252 116.602L4.84858 116.057Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask305_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask305_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21365 116.9C9.21365 116.9 9.50915 113.761 8.21971 112.477C8.21971 112.477 8.71668 116.706 8.21971 117.445L9.21365 116.9Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask306_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask306_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0135 115.603C11.0135 115.603 10.9195 113.424 11.5105 112.581C11.5105 112.581 11.6045 115.876 12.2089 116.809L11.0135 115.603Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask307_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask307_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5513 116.304C22.5513 116.304 22.0544 114.177 19.368 113.243C19.368 113.243 22.1484 115.993 21.7589 116.888L22.5513 116.304Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask308_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask308_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 116.628C19.0993 116.628 18.8038 115.772 20.2947 114.993C20.2947 114.993 19.5963 116.887 19.9992 117.51L19.0993 116.628Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask309_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask309_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4815 117.121C18.4815 117.121 18.4815 114.631 20.2276 113.71C20.2276 113.71 18.8845 116.887 19.3009 118.094L18.4815 117.121Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask310_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask310_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.115 116.368C12.115 116.368 13.1761 112.892 13.7402 112.555C13.7402 112.555 13.0284 116.174 13.4716 116.861L12.115 116.368Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask311_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask311_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0834 116.874C15.0834 116.874 15.8087 113.943 16.8295 113.1C16.8295 113.1 16.4132 115.474 16.4132 116.109L15.0834 116.874Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask312_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask312_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3351 117.043C20.3351 117.043 21.0604 114.111 22.0812 113.268C22.0812 113.268 21.6648 115.642 21.6648 116.277L20.3351 117.043Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask313_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask313_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30032 116.2C8.30032 116.2 7.17206 112.789 7.99139 111.66C7.99139 111.66 6.3393 115.033 7.17206 116.809L8.30032 116.2Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask314_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask314_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4447 116.797C13.4447 116.797 12.5448 114.514 10.1674 113.93C10.1674 113.93 12.7462 115.941 12.4507 117.108L13.4447 116.797Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask315_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask315_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1398 116.861C19.1398 116.861 18.6429 114.734 15.9565 113.8C15.9565 113.8 18.7369 116.55 18.3474 117.445L19.1398 116.861Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask316_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask316_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7316 100.947H88.7021V116.498H92.7316V100.947Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask317_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask317_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7168 98.2098L88.7021 100.947H92.7316L90.7168 98.2098Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask318_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask318_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.726 100.947H100.697V116.498H104.726V100.947Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask319_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask319_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.711 98.2098L100.697 100.947H104.726L102.711 98.2098Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask320_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask320_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.72 100.947H112.691V116.498H116.72V100.947Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask321_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask321_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.706 98.2098L112.691 100.947H116.72L114.706 98.2098Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask322_0_1118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 24,
    width: 172,
    height: 110
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 24.0851H-2.06888V133.567H168.002V24.0851Z",
    fill: "white"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask322_0_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.715 100.947H124.685V116.498H128.715V100.947Z",
    fill: "black"
  }))), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M126.7 98.2098L124.685 100.947H128.715L126.7 98.2098Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M140.709 100.947H136.68V116.498H140.709V100.947Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 98.2098L136.68 100.947H140.696L138.695 98.2098Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M152.704 100.947H148.674V116.498H152.704V100.947Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M150.689 98.2098L148.674 100.947H152.69L150.689 98.2098Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M162.683 98.2098L160.669 100.947H164.685L162.683 98.2098Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 102.58H85.2231V103.683H168.002V102.58Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 107.211H85.2231V108.314H168.002V107.211Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M168.002 111.53H85.2231V112.633H168.002V111.53Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1118",
    x1: 82.4635,
    y1: 122.755,
    x2: 82.4635,
    y2: 7.43188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0286,
    stopColor: "#D1D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0673,
    stopColor: "#A5ABD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1071,
    stopColor: "#838DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#6979BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    stopColor: "#546AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2306,
    stopColor: "#4461AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2743,
    stopColor: "#3A5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3221,
    stopColor: "#365AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#2E4082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8501,
    stopColor: "#22225E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1652"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_1118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7204 43.2386) scale(64.8677 67.7653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D789BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#D886B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#D87EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    stopColor: "#D96FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#D957A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94C9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.644ce9b2840e2911cd3eb35837e2e352.svg";
export { ForwardRef as ReactComponent };